import { Container, Sprite, Texture } from 'pixi.js';
import { Tween, Easing } from '@tweenjs/tween.js';

class WildTextAnim extends Container {
	holder = null;

	constructor(config) {
		super();
		this.config = config;

		this.holder = new Container();
		this.addChild(this.holder);

		this.bg = Sprite.from(Texture.from(config.image));
		this.bg.anchor.set(0.5, 0.5);
		this.holder.addChild(this.bg);

		this.reel_wild_light = Sprite.from(Texture.from('reel_wild_light'));
		this.reel_wild_light.anchor.set(0.5, 0.5);
		this.reel_wild_light.position.set(
			-this.bg.width / 2 - this.reel_wild_light.width / 2,
			0
		);
		this.holder.addChild(this.reel_wild_light);

		this.bgmask = Sprite.from(Texture.from(config.image_mask));
		this.bgmask.anchor.set(0.5, 0.5);
		this.holder.addChild(this.bgmask);
		this.reel_wild_light.mask = this.bgmask;
	}

	animate() {
		this.reel_wild_light.position.set(
			-this.bg.width / 2 - this.reel_wild_light.width / 2,
			0
		);

		new Tween(this.holder.scale)
			.to({ x: 1.2, y: 1.2 }, 150)
			.easing(Easing.Quadratic.Out)
			.onComplete(() => {
				new Tween(this.holder.scale)
					.to({ x: 1, y: 1 }, 450)
					.delay(300)
					.easing(Easing.Back.Out)
					.start();
				new Tween(this.reel_wild_light)
					.to(
						{
							x: this.bg.width / 2 + this.reel_wild_light.width / 2
						},
						450
					)
					.easing(Easing.Linear.None)
					.start();
			})
			.start();
	}
}

export default WildTextAnim;
